import Vue from "vue";

import ShowImage from "./ShowImage/index";
Vue.use(ShowImage);

import ShowVideo from "./ShowVideo/index";
Vue.use(ShowVideo);

import Utils from "./utils";
Vue.use(Utils);



// WEBPACK FOOTER //
// ./src/components/xm-tools/tools.js